import { Dialog, IconButton, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BankAccountForm } from './BankAccountForm';

export const BankAccountDialogForm = ({ formData, title, openModal, setModal, catalogs, handleUpdateForm, saveForm, error, loading }) => {

    return (
        <Dialog
            className='dialogoCrearPagos'
            open={openModal}
            onClose={() => setModal(false)}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>
                    {title}
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setModal(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                {error && <Alert severity="error">{error}</Alert>}
                <BankAccountForm
                    formData={formData}
                    catalogs={catalogs}
                    saveForm={saveForm}
                    loading={loading}
                    handleUpdateForm={handleUpdateForm}
                />

            </div>
        </Dialog>
    )
}
